document.addEventListener('DOMContentLoaded', function () {
  var elms = document.querySelectorAll('#magazine-container .splide');

  for (var i = 0; i < elms.length; i++) {
    new Splide(elms[i], {
      type: 'slide',
      perPage: 1,
      arrows: true,
      pagination: false,
      autoplay: false,
      drag: true,
      speed: 600,
    }).mount();
  }
});